import clsx from 'clsx';
import React from 'react';
import { FlagType } from '../../../../../../@types/product.enum';
import useFlagBadgeStyle from '../../../../../hooks/useFlagBadgeStyle';
import Badge from '../../../../../styled/Badge';
import { useFlags } from '../../providers/FlagsProvider';

interface IPriceBadge {
  className?: string;
}

const PriceBadge = ({ className }: IPriceBadge) => {
  const priceFlag = useFlags(FlagType.price);
  const deliveryFlag = useFlags(FlagType.delivery);

  const flag = priceFlag || deliveryFlag;

  const badgeStyle = useFlagBadgeStyle(flag);

  if (!flag?.productBanner?.text) {
    return null;
  }

  return (
    <Badge
      buttonText={flag?.productBanner?.text}
      className={clsx(className, 'auto-width')}
      productCard
      label={flag?.productBanner?.text}
      style={badgeStyle}
    />
  );
};

export default PriceBadge;
